import React from "react";
import flagsmith from "flagsmith";
import { FlagsmithProvider as Flagsmith } from "flagsmith/react";
import { config } from "../../../lib/config";

let FLAGSMITH_ENVIRONMENT_ID: string;

if (config.env === "local" || config.env === "dev") {
    FLAGSMITH_ENVIRONMENT_ID = "bi7i3ZaEtTsdudqXvhAQsF";
} else if (config.env === "prod") {
    FLAGSMITH_ENVIRONMENT_ID = "LsfCk7CybjwC9Rn9M7zWcX";
} else {
    throw Error("Unknown environment - Env is neither dev nor prod");
}

export const FlagsmithProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <Flagsmith
            flagsmith={flagsmith}
            options={{
                environmentID: FLAGSMITH_ENVIRONMENT_ID,
            }}
        >
            {children as React.ReactElement}
        </Flagsmith>
    );
};
